import React from "react";
import { Text, Box } from "@chakra-ui/react";
const Freshworks = () => {
	return (
		<Box mt="3">
			{/* <AspectRatio mb="2" maxW="100%" h="250px" borderRadius="md" ratio={1}>
				<iframe title="naruto" src="https://www.youtube.com/embed/QhBnZ6NPOY0" allowFullScreen />
			</AspectRatio> */}
			<Box mt="3">
				<Text fontSize="14px" mb="2">
					Step 1: Open your page in WordPress page builder.
				</Text>
				<Text fontSize="14px" mb="2">
					Step 2: Add a Freshworks form block to your webpage.
				</Text>
				<Text fontSize="14px">Step 3: Select this form from the forms dropdown.</Text>
			</Box>
		</Box>
	);
};

export default Freshworks;
